import React, { Component } from 'react';
//import {connect} from 'react-redux';

import './../../../scss/App.scss';

//import { trackingWrapper } from '../../utils/analytics';

class EmailField extends Component {

	constructor(props){
		super(props);

		this.state = {
		}

		//

		this.handleOnChange = this.handleOnChange.bind(this);
		this.handleDelete = this.handleDelete.bind(this);

	}

	componentDidMount(){
		//console.log("EmailField mounted");
	}

	handleOnChange(e){
		let emailObj = this.props.emailObj;

		if(e.target.className === "nameField"){
			emailObj["firstName"] = e.target.value;
		}
		else if(e.target.className === "emailField"){
			emailObj["email"] = e.target.value;
		}

		this.props.handleUpdateEmailField(this.props.emailObj.key, emailObj);
	}

	handleOnChange(ref){
		let emailObj = this.props.emailObj;

		if(ref === this.refs.nameField){
			emailObj["firstName"] = ref.value;
		}
		else if(ref === this.refs.emailField){
			emailObj["email"] = ref.value;
		}

		this.props.handleUpdateEmailField(this.props.emailObj.key, emailObj);
	}

	handleDelete(){
		this.props.handleDeleteEmailField(this.props.emailObj.key);
	}


	renderDeleteBtn(){
		if(this.props.showDelete){
			return(
				<div className="truncateBtn fa-solid fa-trash-can" onClick={this.handleDelete}></div>
			)
		}
	}

	render() {
		let nameError = "";
		let emailError = "";

		if(this.props.errorObj.firstName === false){
			nameError = "error";
		}

		if(this.props.errorObj.email === false){
			emailError = "error";
		}

		return (
			<div className="lineItem">
				<input className={"nameField " + nameError} type="text" placeholder="First Name" value={this.props.emailObj.firstName} ref="nameField" onChange={() => this.handleOnChange(this.refs.nameField)} />
				<input className={"emailField " + emailError} type="text" placeholder="Email Address" value={this.props.emailObj.email} ref="emailField" onChange={() => this.handleOnChange(this.refs.emailField)} />
				{this.renderDeleteBtn()}
			</div>
		);
	}
}

export default EmailField;


// WEBPACK FOOTER //
// ./src/js/components/generator/EmailField.js